import { Card } from 'react-bootstrap';
import CardList from './CardList';

export default function Index() {
    return (
        <Card>
            <Card.Header className="cardHeader">
                <h3>Duplicate UID Fixing — Drugs <small className="text-muted" style={{ fontSize: '14px' }}> (fixing group)</small></h3>
            </Card.Header>
            <Card.Body style={{ backgroundColor: '#dadada', padding: '20px', borderRadius: '0 0 8px 8px' }}>
                <p className="text-muted small mb-3" style={{ background: '#fff', padding: '10px 12px', borderRadius: '6px' }}>
                    {/* Grouped by <code>code_no</code> like your query. */}
                    Each <b>UID</b> group is a <b>card-item</b> under <b>card-list</b>.<br />
                    {/* 1st item keep, rest auto-generate unique.<br /> */}
                    Editable fields live-check via ajax (✓ green / ✕ red). 
                    {/* Update shows progress bar and creative modal. */}
                </p>
                <CardList />
            </Card.Body>
        </Card>
    );
}
